{
	"orderTypes": {
		"label": "Order type",
		"market": "Market",
		"limit": "Limit",
		"stop": "Stop",
		"stop_limit": "Stop Limit",
		"trailing_stop": "Trailing Stop"
	}
}
